import imageMethods from './imageMethods'
export default {
  ...imageMethods,

  replaceVars: (template, data) => {
    if (!data || !template) {
      return ''
    }

    const pattern = /\{(.*?)\}/g
    return template.replace(pattern, (match, token) => data[token])
  },

  generateImageLabel(image) {
    const roomsById = {}
    ;(this.rooms || []).forEach((room) => {
      roomsById[room._id] = room
    })
    const room = (image.objectRoom && roomsById?.[image.objectRoom]) || {}
    const roomName =
      room.type &&
      this.$store.state.objectRoomTypesById?.[room.type]?.[
        'typeName_' + this.lang
      ] +
        ' ' +
        (room.number ?? '')
    const featureName =
      image.feature &&
      this.$store.state.featuresList?.[image.feature]?.['name_' + this.lang]
    return (
      (roomName || '') +
      ' ' +
      (roomName && featureName ? ' / ' : '') +
      (featureName || '')
    )
  },
}
